export const blockIconsCommunicationReviewsNew = (
	<span className='material-symbols-outlined'>reviews</span>
);
